import type { Messages } from '../types';

export const common = {
  cancel: 'Batal',
  retry: 'Cuba lagi',
  back: 'Kembali',
  close: 'Tutup',
  logOut: 'Log keluar',
  couldNotLoad: 'Tidak dapat memuatkan',
  somethingWentWrong: 'Ada masalah. Sila cuba lagi.',
  couldNotLoadNow: 'Tidak dapat memuatkan buat masa ini.',

  pageNotFound: 'Halaman tidak ditemui',
  pageNotFoundBody: 'Pautan ini rosak atau halaman tidak wujud.',
  goHome: 'Pergi ke laman utama',

  updateRequired: 'Kemas kini diperlukan',
  updateRequiredBody: 'Sila kemas kini Tupai untuk meneruskan.',
  updateNow: 'Kemas kini sekarang',
  updateDownloading: 'Sedang menyemak dan memasang kemas kini. Sila biarkan aplikasi dibuka.',
  updateDownloadFailed: 'Kemas kini tidak dapat dipasang. Semak sambungan anda dan cuba lagi.',
  updateRetry: 'Cuba lagi',

  openProfile: 'Buka profil',
  notifications: 'Pemberitahuan',
  noNotifications: 'Tiada pemberitahuan lagi',
  noNotificationsBody:
    'Kerja rumah yang siap, laporan baharu dan permintaan pautan daripada anak anda akan muncul di sini.',
  planChip: {
    trial: 'PERCUBAAN',
    pro: 'PRO',
    pending: 'TERTUNDA',
    payment: 'BAYARAN',
    free: 'PERCUMA',
  },
  notifHomeworkDone: '{childName} telah siap kerja rumah',
  notifReportReady: 'Laporan baharu {childName} sudah sedia',
  notifLinkRequest: '{childName} mahu berhubung dengan anda',
  notifTrialEnding: 'Percubaan percuma anda akan tamat',
  notifChildTrialEnding: 'Percubaan percuma {childName} akan tamat tidak lama lagi',
  notifReviewRequest: 'Semak permintaan',
  notifChildTrialEndsOn: 'Tamat {date} — tambahkan mereka ke pelan anda untuk kekalkan akses penuh',

  navMain: 'Utama',
  navChildren: 'Anak',
  navPractice: 'Latihan',
  navExam: 'Peperiksaan',
  navNews: 'Berita',
  navProfile: 'Profil',

  profileAndSettings: 'Profil & Tetapan',
  childFallback: 'Anak',
  childReports: 'Laporan {childName}',
  childHomework: 'Kerja rumah {childName}',
  childActivity: 'Aktiviti {childName}',

  newsTitle: 'Berita & Tip Ibu Bapa',
  comingSoon: 'Akan Datang',
  newsBody:
    'Kami sedang menyediakan tip tutor dan kemas kini kurikulum untuk anda. Sila semak semula tidak lama lagi.',

  weekOf: 'Minggu {from} – {to}',
  dayToday: 'HARI INI',
  dayYesterday: 'SEMALAM',

  pdfProgressSummary: 'Ringkasan Kemajuan',
  pdfPastDays: 'Tempoh {days} hari',
  pdfAppUsage: 'Penggunaan Apl',
  pdfActiveDays: 'Hari Aktif',
  pdfTotalTime: 'Jumlah Masa',
  pdfAvgPerDay: 'Purata / Hari',
  pdfTwoWeeksAgo: '2 minggu lalu',
  pdfLastWeek: 'Minggu lalu',
  pdfToday: 'Hari ini',
  pdfOverview: 'Gambaran Keseluruhan',
  pdfKeyStrengths: 'Kekuatan Utama',
  pdfAreasToFocus: 'Bidang untuk Fokus',
  pdfRecommendations: 'Cadangan',
  pdfStrengthsFallback: 'Membina kemahiran asas melalui latihan yang kerap.',
  pdfFocusFallback: 'Teruskan latihan harian yang konsisten untuk mengukuhkan semua topik.',
  pdfFooter: 'Dijana oleh Tupai · Tutor Matematik AI',

  toastApproved: 'Permintaan diluluskan!',
  toastRejected: 'Permintaan ditolak.',
  toastRevoked: 'Hubungan dibuang.',
  errLinkActionFailed: 'Tindakan itu tidak berjaya. Sila cuba lagi.',
  errRequestGone:
    'Permintaan ini tidak lagi tersedia — ia mungkin telah dibatalkan atau sudah diuruskan.',
  errRegenerateCode: 'Tidak dapat menjana semula kod anda.',
  errWorksheetFailed: 'Tidak dapat menjana lembaran kerja.',

  errConsentOutdated: 'Skrin ini sudah lapuk. Muat semula atau kemas kini apl, kemudian cuba lagi.',
  errSeatLimit: 'Pelan anda tiada tempat kosong. Naik taraf untuk menambah anak.',
  errTrialSeatLocked:
    'Anda boleh menambah anak setelah percubaan anda bertukar kepada pelan berbayar.',
  errFeatureBlocked: 'Pelan semasa anda tidak merangkumi perkara ini.',
  errUpgradeRequired: 'Naik taraf pelan anda untuk menggunakan ini.',
  errQuotaExhausted:
    'Anda telah menggunakan peruntukan bulan ini. Ia akan diset semula bulan depan.',
  errStudentAlreadyLinked: 'Anak ini sudah berhubung dengan ibu bapa lain.',
  errAlreadyInHousehold: 'Anak ini sudah berada dalam sesuatu pelan.',
  errCooldown: 'Sila tunggu sebentar sebelum mencuba lagi.',
  errNotStarted: 'Tiada apa-apa untuk dipaparkan lagi.',
  errCodeExpired: 'Kod itu telah tamat tempoh. Minta kod baharu.',
  errCodeNotFound: 'Kami tidak menemui kod itu. Semak dan cuba lagi.',
  errPhoneInUse: 'Nombor telefon ini sudah didaftarkan. Sila log masuk.',
  errAccountNotFound: 'Akaun ini tidak wujud.',
  errUnauthorised: 'Sesi anda telah tamat. Sila log masuk semula.',
  errNoHousehold: 'Anda belum mempunyai pelan.',
  pushChannelName: 'Kemas kini pembelajaran',
  pushChannelDescription: 'Kemas kini tentang pembelajaran anak-anak anda',
} as const satisfies Messages['common'];
